module.exports = __webpack_public_path__ + "img/calendar-aduana.54cc6fb2.gif";